//#region src/schema/helpers/should-display-heading.ts
var e = (e, t, n = !1) => t || n ? !0 : e ? e.deprecated === !0 || e.const !== void 0 || e.enum?.length === 1 || "type" in e && e.type !== void 0 || "nullable" in e && e.nullable === !0 || e.writeOnly === !0 || e.readOnly === !0 : !1;
//#endregion
export { e as shouldDisplayHeading };

//# sourceMappingURL=should-display-heading.js.map